<template>
  <div class="slider">
    <div class="present-slider mb-6">
      <div ref="slide" class="slide"></div>

      <template v-if="images.length">
        <div @click="hotelImageSlide('left')" class="slider-left-btn pointer">
          <icon name="angle" width="20px" height="28px" fill="var(--lighten-7-color)" />
        </div>
        <div @click="hotelImageSlide('right')" class="slider-right-btn pointer">
          <icon name="angle" width="20px" height="28px" fill="var(--lighten-7-color)" />
        </div>
      </template>
    </div>

    <div v-show="imagesDescription[sliderPosition]"
         class="mt-4 mb-4 standard-500-text ellipsis"
         :title="imagesDescription[sliderPosition]"
         style="height: 18px;">
      {{imagesDescription[sliderPosition]}}
    </div>
    <div v-show="!imagesDescription[sliderPosition]" class="mt-4 mb-4" style="height: 18px;"></div>

    <!--Вторичный слидер картинок отеля-->
    <div ref="secondSlider"
         @mousedown="startDragSecondSlider($event)"
         @mousemove="doDragSecondSlider($event)"
         class="second-slider">
      <div v-for="(item, key) in images"
           :key="key"
           @click="hotelImageSlide(key)"
           :style="{backgroundImage: `url('${item}')`}"
           :class="['second-slide',{'active': sliderPosition === key}]">
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "LargeSlider",
        data() {
            return {
                sliderPosition: 0,
                dragSecondSlider: false,
                secondSliderX: 0,
                secondSliderPosition: 0,
            }
        },
        props: {
            images: {
                type: Array,
                default: () => []
            },
            imagesDescription: {
                type: Array,
                default: () => []
            },
            type: {
                type: String,
                default: "Tour"
            }
        },
        created() {
            window.addEventListener("mouseup", this.stopDragSecondSlider);
        },
        mounted() {
            this.setImages()
        },
        methods: {
            setImages() {
                if (this.images[0]) {
                    this.$refs.slide.style.backgroundImage = `url('${this.images[0].replace("small160x90", "big")}')`;
                    this.$refs.slide.style.backgroundSize = "102%";
                    this.sliderPosition = 0;
                } else {
                    let path = this.$store.getters['getPath'];
                    this.$refs.slide.style.backgroundImage = `url('${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=639&type=big&name=null&imageType=${this.type.toLowerCase()}s')`;
                }
            },
            hotelImageSlide(to) {
                let position = this.sliderPosition;
                if (to === 'right') {
                    if (this.images[position + 1]) {
                        this.$refs.slide.style.backgroundImage = `url('${this.images[position + 1].replace("small160x90", "big")}')`;
                        this.sliderPosition++
                    } else {
                        this.sliderPosition = 0;
                        this.$refs.slide.style.backgroundImage = `url('${this.images[0].replace("small160x90", "big")}')`;
                    }
                } else if (to === 'left') {
                    if (this.images[position - 1]) {
                        this.$refs.slide.style.backgroundImage = `url('${this.images[position - 1].replace("small160x90", "big")}')`;
                        this.sliderPosition--
                    } else {
                        this.sliderPosition = this.images.length - 1;
                        this.$refs.slide.style.backgroundImage = `url('${this.images[this.sliderPosition - 1].replace("small160x90", "big")}')`;
                    }
                } else {
                    if (this.images[to]) {
                        this.$refs.slide.style.backgroundImage = `url('${this.images[to].replace("small160x90", "big")}')`;
                        this.sliderPosition = to;
                    }
                }
                if (!this.dragSecondSlider) {
                    this.$refs.secondSlider.scrollTo(this.sliderPosition * 173, 0)
                }
            },
            startDragSecondSlider(e) {
                this.secondSliderX = e.x;
                this.secondSliderPosition = this.$refs.secondSlider.scrollLeft;

                this.dragSecondSlider = true;
            },
            stopDragSecondSlider() {
                setTimeout(() => this.dragSecondSlider = false, 100)
            },
            doDragSecondSlider(e) {
                e.preventDefault();
                if (this.dragSecondSlider) {
                    this.$refs.secondSlider.scrollTo((this.secondSliderX - e.x) + this.secondSliderPosition, 0)
                }
            },
        },
        watch: {
            images() {
                this.setImages()
            }
        },
        beforeDestroy() {
            window.removeEventListener("mouseup", this.stopDragSecondSlider);
        }
    }
</script>

<style scoped>
  /**SLIDER**/
  .slider {
    width: 680px;
  }

  .slider .present-slider {
    position: relative;
  }

  .slider .present-slider .slide {
    width: 680px;
    height: 380px;
    border-radius: 6px;
    background-size: 102%;
    background-repeat: no-repeat;
    background-position: 50%;
    transition: all .2s;
  }

  .slider .present-slider .slider-right-btn,
  .slider .present-slider .slider-left-btn {
    position: absolute;
    top: 50%;
  }

  .slider .present-slider .slider-left-btn {
    left: -30px;
    transform: translateY(-50%) rotate(90deg);
  }

  .slider .present-slider .slider-right-btn {
    right: -30px;
    transform: translateY(-50%) rotate(-90deg);
  }

  .slider .second-slider {
    display: flex;
    overflow: hidden;
    width: 680px;
  }

  .slider .second-slider .second-slide {
    position: relative;
    border-radius: 6px;
    min-width: 161px;
    height: 105px;
    background-color: #ededed;
    background-size: 102%;
    background-position: 50%;
    cursor: pointer;
  }

  .slider .second-slider .second-slide:not(:last-child) {
    margin-right: 12px;
  }

  .slider .second-slider .second-slide:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0);
    transition: all .2s;
  }

  .slider .second-slider .active.second-slide:before,
  .slider .second-slider .second-slide:hover:before {
    background-color: rgba(0, 0, 0, .3);
  }
</style>